export default "__VITE_ASSET__Cyiri77B__"